import React from 'react';
import MaterialCheckbox from '@material-ui/core/Checkbox';
import { makeStyles } from '@material-ui/styles';
import './index.scss';

/**
 * Generic checkbox component to be used for abstracting away univeral functionality
 */

const useStyles = makeStyles({
  root: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
    padding: 5,
    margin: '0 3px',
  },
  icon: {
    borderRadius: 0,
    width: 16,
    height: 16,
    boxShadow: 'none',
    backgroundColor: '#ff',
    backgroundImage: 'none',
    border: '1px solid #0077C8',
    'input:hover ~ &': {
      backgroundColor: '#ebf1f5',
    },
    'input:disabled ~ &': {
      boxShadow: 'none',
      background: 'rgba(206,217,224,.5)',
    },
  },
  checkedIcon: {
    backgroundColor: '#0077C8',
    backgroundImage:
      'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
    '&:before': {
      display: 'block',
      width: 16,
      height: 16,
      backgroundImage:
        "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
        " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
        "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
      content: '""',
    },
    'input:hover ~ &': {
      backgroundColor: '#106ba3',
    },
  },
  indeterminateIcon: {
    backgroundColor: '#0077C8',
    backgroundImage:
      'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
    '&:before': {
      display: 'block',
      width: 16,
      height: 16,
      backgroundImage:
        "url(\"data:image/svg+xml;charset=utf8,%3Csvg width='17' height='17' xmlns='http://www.w3.org/2000/svg'%3E%3Cg " +
        "fill='none' fill-rule='evenodd'%3E%3Crect fill='%230077C8' rx='1'/%3E%3Cpath stroke='%23FFF' " +
        "stroke-width='2' stroke-linecap='square' d='M4 8.5h8'/%3E%3C/g%3E%3C/svg%3E\")",
      content: '""',
    },
    'input:hover ~ &': {
      backgroundColor: '#106ba3',
    },
  },
});

const Checkbox = ({ ...props }) => {
  const classes = useStyles();
  return (
    <MaterialCheckbox
      disableRipple
      className={classes.root}
      color="default"
      checkedIcon={<span className={classes.checkedIcon} />}
      indeterminateIcon={<span className={classes.indeterminateIcon} />}
      icon={<span className={classes.icon} />}
      {...props}
    />
  );
};

export default Checkbox;
